import {UserDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'SET_USER_PASSWORD';

export async function setUserPassword(userToken: string, userId: string, bodyPassword: any) {
    try {
        const result = await UserDao.setUserPassword(userToken,  userId,  bodyPassword);

        return result;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la modification du mot de passe.',
            error: error
        });
    }
}
